import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';


const NewHeader = () => {

    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const offset = window.scrollY;

            if (offset > 200) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Cleanup function to remove event listener
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };

    }, []);


   






    return (
        <header className="newHeader">
           

            <div className={`${isSticky ? 'sticky' : ''}`}>
             
                <Navbar />
            </div>






           

        </header>


    )
}

export default NewHeader;
